import { useStore } from '@nanostores/react';
import { useEffect, useRef, useState } from 'react';
import { OpenAPI } from '../../api/core/OpenAPI';
import { request as __request } from '../../api/core/request';

export const StripeOAuthRedirectHandler = () => {
  const org = useStore($org);
  const effectRunRef = useRef(false);
  const [message, setMessage] = useState('Processing Stripe Authentication...');

  useEffect(() => {
    if (!org || effectRunRef.current) return; // Prevent duplicate execution
    effectRunRef.current = true;

    const handleStripeCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const scope = urlParams.get('scope');

      const orgId = org?.id || localStorage.getItem('stripe_org_id');

      if (!code) {
        console.error('Invalid state or missing authorization code.');
        setMessage('Authentication failed: Missing authorization code.');
        return;
      }

      if (!orgId) {
        console.error('Invalid state or missing organization ID.');
        setMessage('Authentication failed: Missing organization ID.');
        return;
      }

      const body: {
        Code: string;
        State: string;
        OrgId?: string;
        Scope: string;
      } = {
        Code: code,
        State: state ?? '',
        Scope: scope ?? '',
      };

      if (org) {
        body.OrgId = org.id;
      }

      try {
        await __request(OpenAPI, {
          method: 'POST',
          url: `/integrations/stripe/getAccessToken`,
          body,
          mediaType: 'application/json',
        });
        setMessage('Authentication successful, redirecting to integrations...');
        localStorage.removeItem('stripe_org_id'); // Clean up
        window.location.href = `/settings?activeNav=integrations`;
      } catch (error) {
        setMessage('Authentication unsuccessful, please try again.');
        localStorage.removeItem('stripe_org_id'); // Clean up even on error
        window.location.href = `/settings?activeNav=integrations`;
        console.error('Error during Stripe authentication callback:', error);
      }
    };

    handleStripeCallback();
  }, [org]);

  return (
    <div>
      <p>{message}</p>
    </div>
  );
};
